/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import prism from 'react-syntax-highlighter/dist/cjs/styles/prism/prism';

import { Typography2, breakpoints } from '@coursera/cds-core';

import CopyToClipboardButton from 'bundles/authoring/common/components/CopyToClipboardButton';

type Props = {
  language: string;
  codeString: string;
};

const styles = {
  container: css`
    margin: 20px 0;
  `,
  codeBlock: css`
    position: relative;
    font-size: 14px;
  `,
  copyToClipBoardContainer: () => css`
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  languageLabel: css`
    text-align: right;
    background-color: lightgray;
    max-width: fit-content;
    padding: 0 5px;
  `,
};

const CodeBlock = ({ language, codeString }: Props) => {
  const isBash = language === 'bash';

  return (
    <div css={styles.container}>
      <div css={styles.languageLabel}>
        <Typography2 component="span" variant="subtitleMedium">
          {language.toUpperCase()}
        </Typography2>
      </div>
      <div css={styles.codeBlock}>
        {!isBash && (
          <div css={styles.copyToClipBoardContainer}>
            <CopyToClipboardButton value={codeString} copiedMessage="Copied" />
          </div>
        )}
        <SyntaxHighlighter language={language} style={prism} showLineNumbers={!isBash}>
          {codeString}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export default CodeBlock;
